import _ from 'lodash';

const nameConfig = {
    formatMode: 'default',
    mode: 'default',
    visibleFields: ['Suffix', 'FirstName', 'Prefix', 'LastName', 'Middlename', 'Name']
};

function _append(sb, fieldId, value) {
    if (!_.isEmpty(value) && _.includes(nameConfig.visibleFields, fieldId)) {
        sb.push(value);
    }
}

function _format(person, delimiter) {
    const lastName = person.lastNameKanji || person.lastName;
    const firstName = person.firstNameKanji || person.firstName;
    const middleName = person.middleName;
    const suffix = person.suffix;
    const result = [];
    switch (nameConfig.formatMode) {
        case 'default':
            _append(result, 'FirstName', firstName);
            _append(result, 'MiddleName', middleName);
            _append(result, 'LastName', lastName);
            _append(result, 'Suffix', suffix);
            break;
        default:
            break;
    }
    return result.join(delimiter);
}

function _formatWithSuffix(person, suffix, delimiter) {
    const lastName = person.lastNameKanji || person.lastName;
    const firstName = person.firstNameKanji || person.firstName;
    const middleName = person.middleName;
    const result = [];
    switch (nameConfig.formatMode) {
        case 'default':
            _append(result, 'FirstName', firstName);
            _append(result, 'MiddleName', middleName);
            _append(result, 'LastName', lastName);
            _append(result, 'Suffix', suffix);
            break;
        default:
            break;
    }
    return result.join(delimiter);
}

export default {
    getDisplayName: (person, delimiter)=> {
        return _format(person, delimiter);
    },
    getDisplayNameSuffix: (person, suffix, delimiter) => {
        return _formatWithSuffix(person, suffix, delimiter);
    }
};
